// extracted by mini-css-extract-plugin
module.exports = {"jobOffer":"joboffer_jobOffer__3N37y","Loader":"joboffer_Loader__1k_zg"};